import store from '@/store';

export default [
  {
    path: '/cancellation-requests',
    name: 'cancellation',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Запити на ануляцію полісів'
    },
    // beforeEnter: (to, from, next) => {
    //     if (store.getters.USER_INFO.isActivePenalty) {
    //         next();
    //     } else {
    //         next({name: 'prime'})
    //     }
    // },
    component: () => import('../pages/cancellation-requests-page')
  },
];

